module.exports = __webpack_public_path__ + "img/step_3.9afc8e73.webp";